const getters = {
  stuId: state => state.user.stuId,
  token: state => state.user.token,
  baseApiUrl: state => window.baseapi.baseApiUrl, // 继续教育
  ZXbaseApiUrl: state => window.baseapi.ZXbaseApiUrl, // 专项学习
  DLbaseApiUrl: state => window.baseapi.DLbaseApiUrl, // 道路旅客
  platform: state => state.user.platform, // 0继续教育  1专项学习
  ProfessionId: state => state.user.ProfessionId // 货运1  客运2 危险3  专项4  出租5
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js